import DeleteTicketType from "./DeleteTicketType";

export default DeleteTicketType